<template>
	<div class="drv-table-wrap overflow-auto">
		<table v-if="columns.length" class="drv-table">
			<thead class="drv-table__head">
				<b-tr class="drv-table__tr">
					<th
						v-for="column in columns"
						:key="column.uniqueId"
						class="drv-table__th"
					>
						<span
							class="drv-table__th-inner"
							:style="{ minWidth: column.width }"
						>
							{{ column.label }}
							<span
								v-if="column.sortable"
								class="drv-table__th-sort"
							>
								<a
									@click.prevent="
										handleSortColumn(column.key, '-')
									"
									class="drv-table__th-sort--icon drv-table__th-sort--icon-asc"
									href
								>
									<b-icon
										:icon="
											isColumnActive(column.key, '-')
												? 'caret-up-fill'
												: 'caret-up'
										"
									></b-icon>
								</a>
								<a
									@click.prevent="
										handleSortColumn(column.key, '')
									"
									class="drv-table__th-sort--icon drv-table__th-sort--icon-desc"
									href
								>
									<b-icon
										:icon="
											isColumnActive(column.key, '')
												? 'caret-down-fill'
												: 'caret-down'
										"
									></b-icon>
								</a>
							</span>
						</span>
					</th>
				</b-tr>
			</thead>
			<tbody class="drv-table__tbody">
				<template v-if="cpItems.length">
					<tr
						v-for="item in cpItems"
						:key="item.key"
						class="drv-table__tr"
					>
						<td
							v-for="column in columns"
							:key="column.uniqueId"
							class="drv-table__td"
						>
							<span class="drv-table__cell">
								<template v-if="column.decimals">{{
									parseFloat(
										item.values[column.key] || 0
									).toFixed(column.decimals)
								}}</template>
								<template v-else>{{
									item.values[column.key]
								}}</template>
							</span>
						</td>
					</tr>
				</template>
				<template v-else>
					<tr>
						<td :colspan="columns.length" class="p-2">
							No results found.
						</td>
					</tr>
				</template>
			</tbody>
		</table>
		<p v-else class="mb-0">No columns selected.</p>
	</div>
</template>

<script>
import { getUniqueID } from "./../utils/arrays";
import { DEFAULT_SORT_TYPE } from "./../utils/constants";

export default {
	name: "drv-table",
	props: {
		columns: {
			type: Array,
			required: true,
		},
		items: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			sortOrder: DEFAULT_SORT_TYPE,
			activeColumn: null,
		};
	},
	computed: {
		sortingData() {
			return {
				key: this.activeColumn,
				order: this.sortOrder,
			};
		},
		cpItems() {
			return this.items.map((item) => {
				return {
					key: getUniqueID(`item-${item}`),
					values: item,
				};
			});
		},
	},
	methods: {
		isColumnActive(column, sorting = null) {
			if (null !== sorting)
				return (
					column === this.activeColumn && sorting === this.sortOrder
				);

			return column === this.activeColumn;
		},
		handleSortColumn(column, sorting = "") {
			this.activeColumn = column;
			this.sortOrder = sorting;

			this.$emit("sort", this.sortingData);
		},
	},
};
</script>
